import { render } from "./OrderDetail.vue?vue&type=template&id=6a446328"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=6a446328&lang=less"
script.render = render

export default script